import { render, staticRenderFns } from "./Boton.vue?vue&type=template&id=2944ab4c&scoped=true"
import script from "./Boton.vue?vue&type=script&lang=js"
export * from "./Boton.vue?vue&type=script&lang=js"
import style0 from "./Boton.vue?vue&type=style&index=0&id=2944ab4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2944ab4c",
  null
  
)

export default component.exports